'use client';

/**
 * Shared auth chrome for client authentication screens.
 * Brand mark: robot agent holding rose-gold M (prototype asset).
 */
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { ThemeToggle } from '@/shared/theme';

type AuthNavbarProps = {
  /** Secondary line under Mechagora */
  subtitle?: string;
};

export function AuthNavbar({ subtitle = 'Trading Platform' }: AuthNavbarProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 900);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <>
      <a href="#main-content" className="auth-skip-link">
        Skip to main content
      </a>
      <nav className="login-navbar" aria-label="Primary">
        <div className="login-navbar-container">
          <a href="/" className="login-navbar-brand">
            <span className="login-logo-mark" aria-hidden>
              <Image
                src="/assets/brand/logo-agent-m.png"
                alt=""
                width={44}
                height={44}
                className="login-logo-img"
                priority
              />
            </span>
            <div className="login-navbar-brand-text">
              <span className="login-brand-title">Mechagora</span>
              <span className="login-brand-subtitle">{subtitle}</span>
            </div>
          </a>

          <div className="login-navbar-actions">
            <span className="login-navbar-meta" aria-hidden>
              <span className="login-navbar-meta-mark" />
              <span className="login-navbar-meta-label">secure sign-in</span>
            </span>
            <ThemeToggle size={isMobile ? 'small' : 'medium'} />
          </div>
        </div>
      </nav>
    </>
  );
}

export default AuthNavbar;
